import { Directive, effect, inject, input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[coinTab]',
  exportAs: 'v2Tab'
})
export class V2TabDirective {
  public template = inject(TemplateRef<unknown>);

  public readonly content = input.required<string | TemplateRef<unknown>>({ alias: 'coinTab' });
  public readonly icon = input<string>();
  public readonly isDisabled = input(false);
  public readonly disabledTooltip = input('');

  /** If set to true, tab content will only load when selected */
  public readonly lazy = input(false);
  /** If set to true, lazy tabs will remain loaded after being unselected */
  public readonly cache = input(false);

  public readonly route = input<string>();
  public readonly isHidden = input(false);

  constructor() {
    this.validateInputs();
  }

  public matchesUrl(url: string): boolean {
    const route = this.route();
    if (!route) return false;

    const normalizedRoute = route.startsWith('/') ? route : `/${route}`;
    const normalizedUrl = url.split('?')[0].split('#')[0];

    return normalizedUrl === normalizedRoute;
  }

  private validateInputs(): void {
    effect(() => {
      if (this.cache() && !this.lazy()) throw new Error('Caching tabs requires them to be lazy');
      if (this.route() && this.lazy()) throw new Error('Tabs cannot be both routed and lazy');
    });
  }
}
